import React, { Suspense } from 'react'
import { PageWrapper, Root } from '@fs/identity.js'
import { AuthRoute } from '@fs/zion-router'
import { Skeleton, Separator } from '@fs/zion-ui'
import ReviewLoadingFragment from './ReviewLoadingFragment'

const ReviewPage = React.lazy(() => import('./ReviewPage'))
const ReviewBirthDatePage = React.lazy(() => import('./ReviewBirthDatePage'))

const header = {
  signedIn: false,
  showMobileDrawer: false,
  showNavLinksDesktop: false,
  showFHCLocations: false,
  showUserOrAuth: false,
}
const footer = { hidden: true }

function ReviewSkeleton() {
  return (
    <>
      <Skeleton.H4 />
      <Separator />
      <Skeleton.Paragraph lineCount={3} size="sm" />
      <Separator size="md" />
      <ReviewLoadingFragment />
      <Skeleton.Button minWidth="100%" />
    </>
  )
}

export default function ReviewRoutes() {
  return (
    <Root analytics header={header} footer={footer}>
      <PageWrapper maxWidth="nano">
        <Suspense fallback={<ReviewSkeleton />}>
          <AuthRoute exact path="/review" component={ReviewPage} />
          <AuthRoute exact path="/review/birth-date" component={ReviewBirthDatePage} />
        </Suspense>
      </PageWrapper>
    </Root>
  )
}
